// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    box-sizing: border-box;
}

.wrap {
    max-width: 600px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 2rem;
    gap: 2rem;
    align-items: center;
}
img{
    width: 100%;
    height: auto;
}
/* @media(max-width: 600px) {
 .wrap {
    display: block;
 }
 .wrap p {
    margin-block-start: -3rem;
    margin-inline-start: 1rem;
    background: rgb(0 0 0 /0.3);
    position: relative;
 } 
}*/
.wrap p {
    margin-top: -5rem;
    margin-left: 3rem;
    background: rgba(225, 255, 255,0.5);
    position: relative;
 }`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,8BAA8B;IAC9B,cAAS;IAAT,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;;;;;;;;;;EAUE;AACF;IACI,iBAAyB;IACzB,iBAAiB;IACjB,mCAAiC;IACjC,kBAAkB;CACrB","sourcesContent":["* {\n    box-sizing: border-box;\n}\n\n.wrap {\n    max-width: 600px;\n    margin: 0 auto;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 2rem;\n    align-items: center;\n}\nimg{\n    width: 100%;\n    height: auto;\n}\n/* @media(max-width: 600px) {\n .wrap {\n    display: block;\n }\n .wrap p {\n    margin-block-start: -3rem;\n    margin-inline-start: 1rem;\n    background: rgb(0 0 0 /0.3);\n    position: relative;\n } \n}*/\n.wrap p {\n    margin-block-start: -5rem;\n    margin-left: 3rem;\n    background: rgb(225 255 255 /0.5);\n    position: relative;\n }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
